import { Box, BoxProps, combineSx } from '@chronosphereio/chrono-ui';

export type SeriesMarkerVariant = 'solid' | 'striped' | 'dashed';

interface SeriesMarkerProps extends BoxProps {
  color: string;
  variant?: SeriesMarkerVariant;
}

const MARKER_WIDTH = 16;
const MARKER_MARGIN_RIGHT = 1.5;

export function SeriesMarker(props: SeriesMarkerProps) {
  const { color, variant = 'solid', sx } = props;

  let background: string;
  if (variant === 'striped') {
    // Tight, high-contrast diagonal stripes for compare-mode series.
    background = `repeating-linear-gradient(
          135deg,
          ${color},
          ${color} 2px,
          transparent 2px,
          transparent 4px
        )`;
  } else if (variant === 'dashed') {
    // Even horizontal dashes for threshold reference lines.
    background = `repeating-linear-gradient(
          90deg,
          ${color},
          ${color} 3px,
          transparent 3px,
          transparent 6px
        )`;
  } else {
    background = color;
  }
  return (
    <Box
      width={MARKER_WIDTH}
      sx={combineSx(
        {
          height: '4px',
          marginTop: 0,
          marginRight: MARKER_MARGIN_RIGHT,
          verticalAlign: 'text-top',
          background,
        },
        sx
      )}
    />
  );
}
